import {Utilities} from '@shared/utilities/utilities.model';
import {ListModel} from '@shared/models/list.model';
import {ContractItemListModel} from './contract-item-list.model';
import {ContractsUtilitiesModel} from '@cc-commons/utilities/contracts-utilities.model';
import {ContractDetailsModel} from '@cc-commons/models/contract-details.model';

export class ContractsListModel extends ListModel {

	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			model.items.forEach((item) => {
				(item as ContractItemListModel).state_id = ContractDetailsModel.getStateID((item as ContractItemListModel).state);
				this.items.push(item as ContractItemListModel)
			});
		}
	}
}
